
export default {
  name: 'sign-in',
  layout: 'auth',
  middleware: 'auth',
  auth: 'guest',
};
